import request from '@/utils/request'

export function getMyCoupon(params) {
  return request({
    url: '/product/coupon/my/group',
    method: 'get',
    params,
  })
}
export function getCouponCenter(params) {
  return request({
    url: '/product/coupon/center/group',
    method: 'get',
    params,
  })
}
export function getCoupon(id) {
  return request({
    url: '/product/coupon/get-coupon/' + id,
    method: 'put',
  })
}
